import { devices } from '@src/styles/theme';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const images = [
  '/imgs/sponser/four-1.svg',
  '/imgs/sponser/four-2.svg',
  '/imgs/sponser/four-3.svg',
];

const ImageSlider = () => {
  return (
    <SliderContainer>
      {[...images, ...images, ...images].map((image, i) => (
        <Slide key={i} index={i}>
          <img src={image} alt={`Image ${i + 1}`} />
        </Slide>
      ))}
    </SliderContainer>
  );
};

const slideAnimation = keyframes`
  0% {
    transform: translateX(-200%);
  }
  100% {
    transform: translateX(0);
  }
`;

const SliderContainer = styled.div`
  display: flex;
  overflow: hidden;
  gap: 20px;
  margin-top: 60px;
  @media ${devices.tablet} {
    margin-top: 40px;
  }
`;

const Slide = styled.div<{ index: number }>`
  flex: 0 0 33.33%; /* 이미지가 한 번에 3개씩 보이도록 설정 */
  text-align: center;
  animation: ${slideAnimation} 15s linear infinite
    ${({ index }) => index * -15}s;
  opacity: 1;
  > img {
    border-radius: 20px;
  }
  @media ${devices.tablet} {
    flex: 0 0 100%;
    > img {
      width: 100%;
    }
  }
`;

export default ImageSlider;
